import React from 'react';
import NumberFormat from 'react-number-format';

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.floatValue,
          },
        });
      }}
      thousandSeparator="."
      decimalSeparator=","
      displayType="text"
      type="text"
      decimalScale={2}
      fixedDecimalScale={true}
      isNumericString
    />
  );
}

export { NumberFormatCustom };
